import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Messages } from 'src/app/constants/messages';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { Utilities } from 'src/app/constants/utilities';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-alertrule-modal',
  templateUrl: './alertrule-modal.component.html',
  styleUrls: ['./alertrule-modal.component.css'],
})
export class AlertruleModalComponent implements OnInit, OnDestroy {
  alertRuleForm: any;
  formSubmitted: boolean = false;
  // attribute: any = ['alertSeverity', 'alertAction', 'alertCategory', 'categoryNature', 'unitOfMeasurement', 'typ', 'zoneRiskType', 'classType']
  alertSeveritydd: any = [];
  alertActionsdd: any = [];
  alertCategorydd: any = [];
  alertCategoryNaturedd: any = [];
  uom: any = [];
  scope: any = [];
  classType: any = [];
  zoneRiskTypeList: any = [];
  alertListForTenant: any = [];
  isShown: any;
  siteList: any = [];
  global: any;
  errorMessage: any = null;
  formLabelName: string = 'Auto Update Delay';
  autoCloseTrigger: boolean = false;

  private _alertIdList: any = [];
  private _afterClosedSubscription: Subscription;
  private _alertIdListSubscription: Subscription;
  private _siteListSubscription: Subscription;
  private _insertAlertRuleSubscription: Subscription;
  private _updateAlertRuleSubscription: Subscription;
  private _allowDuplicatesSub: Subscription;

  @Input() siteId: any;
  @Input() alertRuleAdd: any; //add
  @Input() alertRuleData: any; //Edit
  @Input() alertRuleEdit: any; //Edit true
  @Input() alertRuleView: any;
  @Input() tabType: any;
  @Input() pageType : string; //Alert Profile view

  constructor(
    private _activeModal: NgbActiveModal,
    private _fb: FormBuilder,
    private _service: ServicecallService,
    private _dialog: MatDialog
  ) {
    this._buildForm();
  }

  ngOnInit(): void {
    this._checkValidity();
    this._configurationInfo();
  }
  ngOnDestroy(): void {
    this._afterClosedSubscription?.unsubscribe();
    this._alertIdListSubscription?.unsubscribe();
    this._siteListSubscription?.unsubscribe();
    this._insertAlertRuleSubscription?.unsubscribe();
    this._updateAlertRuleSubscription?.unsubscribe();
    this._allowDuplicatesSub?.unsubscribe();
  }
  autoCloseChange(value: any) {
    this._autoCloseFieldChange(value.checked);
    this.alertRuleForm.patchValue({ autoClose: value.checked });
  }

  activeChange(value: any) {
    this.alertRuleForm.patchValue({ active: value.checked });
  }

  smsChange(value: any) {
    this.alertRuleForm.patchValue({ sms: value.checked });
  }

  emailChange(value: any) {
    this.alertRuleForm.patchValue({ email: value.checked });
  }

  c2dChange(value: any) {
    this.alertRuleForm.patchValue({ c2d: value.checked });
  }

  webNotificationChange(value: any) {
    this.alertRuleForm.patchValue({ webNotification: value.checked });
  }
  pushNotificationChange(value: any) {
    this.alertRuleForm.patchValue({ pushNotification: value.checked });
  }

  getAlertList(event: {
    isUserInput: any;
    source: { value: any; selected: any };
  }) {
    if (event.isUserInput) {
      if (event.source.selected === true) {
        this.siteId = event.source.value;
        this._getAlerts();
      }
    }
  }
  onSubmit() {
    this.formSubmitted = true;
    if (this.alertRuleForm.invalid) {
      return;
    }
    if (this.alertRuleEdit) {
      this._updateAlertRule();
    }
    if (this.alertRuleAdd) {
      this._insertAlertRule();
    }
  }
  alertValue: any;
  onSelectEvent(item: any) {
    this.alertValue = item.value;
    let data: any = this.alertListForTenant.find(
      (x: any) => x.alertId === Number(item['value'])
    );
    this._patchValue(data);
  }

  closeModal() {
    if (this.alertRuleForm.dirty) {
      let dialogRef = this._dialog.open(AlertDialogComponent, {
        data: { msg: Messages.UNSAVED_CHANGES, type: null },
        disableClose: true,
      });
      this._afterClosedSubscription = dialogRef
        .afterClosed()
        .subscribe((result) => {
          if (result) {
            this._activeModal.close();
          }
        });
    } else {
      this._activeModal.close();
    }
  }

  private _checkValidity() {
    if (this.tabType === 'site') {
      this.isShown = 'site';
      this._getSiteList();
    } else if (this.tabType === 'tenant') {
      this.isShown = 'tenant';
      this._getAlerts();
    } else if (this.tabType === 'global') {
      this.isShown = 'global';
      this.alertValue = this.alertRuleAdd
        ? this.alertRuleAdd['alertId']
        : this.alertRuleData['alertId'];
      this._getAlerts();
    }
  }

  private _getAlerts() {
    this._alertIdList.length = 0;
    this.alertListForTenant.length = 0;
    let _postData: any = {
      siteId: this.siteId ? this.siteId : null,
      tab: this.tabType,
    };
    this._alertIdListSubscription = this._service
      .alertIdList(_postData)
      .subscribe((res: any) => {
        if (res['status']) {
          let data: any = [];
          this._alertIdList = [];
          this.alertListForTenant = [];
          data = res['response']['data'];
          if (data.length > 0) {
            this.alertListForTenant = data;
            data.forEach((element: any, index: number) => {
              let d: any = {
                id: index,
                name: element['alertId'] + '-' + element['alertDesc'],
              };
              this._alertIdList = this._alertIdList.concat(d);
            });
            if (this.alertListForTenant.length == 1) {
              this.alertValue = this.alertListForTenant[0].alertId;
              this._patchValue(this.alertListForTenant[0]);
            }
          }
        }
      });
  }
  private _getSiteList() {
    this.siteList.length = 0;
    this._siteListSubscription = this._service
      .siteList(this.siteId)
      .subscribe((res: any) => {
        this.siteList = res['response']['data'];
        // const site = JSON.parse(sessionStorage.getItem('siteId')|| '{}');
        // if(site) {
        //  this.siteList = this.siteList.filter((item:any)=>item._id===site);
        //  this.alertRuleForm.patchValue({siteId:this.siteList[0]._id});
        //  this.siteId = this.siteList[0]._id;
        //  this.getAlerts();
        // }
        const site = sessionStorage.getItem('plantProfileSiteId')
          ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
          : null;
        if (site) {
          this.siteList = this.siteList.filter(
            (item: any) => item._id === site
          );
          this.alertRuleForm.patchValue({ siteId: this.siteList[0]._id });
          this.siteId = this.siteList[0]._id;
          this._getAlerts();
        } else {
          const site = JSON.parse(sessionStorage.getItem('siteId') || '{}');
          if (site) {
            this.siteList = this.siteList.filter(
              (item: any) => item._id === site
            );
            this.alertRuleForm.patchValue({ siteId: this.siteList[0]._id });
            this.siteId = this.siteList[0]._id;
            this._getAlerts();
          }
        }
      });
  }

  private _insertAlertRule() {
    this.errorMessage = null;
    let userId = localStorage.getItem('userId');
    this.alertRuleForm.value['group'] =
      this.tabType === 'global' ? 'system' : 'userdefined';
    this.alertRuleForm.value['metadata'] = {
      createdBy: localStorage.getItem('userId')
        ? localStorage.getItem('userId')
        : null,
    };
    if (this.tabType !== 'global') {
      this.alertRuleForm.value['tenantId'] = localStorage.getItem('tenantId')
        ? localStorage.getItem('tenantId')
        : null;
    }
    switch (this.tabType) {
      case 'site':
        this.alertRuleForm.value.type = 'site';
        break;
      case 'tenant':
        this.alertRuleForm.value.type = 'tenant';
        break;
      case 'global':
        this.alertRuleForm.value.type = this.alertRuleForm.value.type;
        break;
    }
    if (!this.alertRuleForm.value['allowDuplicates']) {
      this.alertRuleForm.value['duplicateDuration'] = null;
    }
    
    let _postData: any = {
      set: [this.alertRuleForm.value],
      tab: this.tabType === 'global' ? 'system' : this.tabType,
    };

    this._insertAlertRuleSubscription = this._service
      .insertAlertRule(_postData)
      .subscribe((res: any) => {
        if (res['status']) {
          if (res['response']['inserted'] === true) {
            this._service.toasterService({
              type: 'success',
              msg: res['response']['message'],
            });
            this._activeModal.close(true);
          } else {
            this.errorMessage =
              res['response']['message'] + ' - ' + res['response']['error'];
            // this._service.toasterService({ type: 'error', msg: res['response']['message'] });
          }
        } else {
          this.errorMessage =
            res['response']['message'] + ' - ' + res['response']['error'];
          // this._service.toasterService({ type: 'error', msg: res['response']['message'] });
        }
      });
  }

  private _updateAlertRule() {
    this.errorMessage = null;
    let userId = localStorage.getItem('userId')
      ? localStorage.getItem('userId')
      : null;
    let changedValues = Utilities.getDirtyValues(this.alertRuleForm);
    
    if (!this.alertRuleForm.value['allowDuplicates'] && 'duplicateDuration' in changedValues) {
      delete changedValues['duplicateDuration'];
    }
    
    let _postData: any = {
      _id: this.alertRuleData['_id'],
      alertId: this.alertRuleData['alertId'],
      tab: this.tabType === 'global' ? 'system' : this.tabType,
      metadata: { createdBy: userId },
      set: changedValues,
      action: true,
    };
    this._updateAlertRuleSubscription = this._service
      .updateAlertRule(_postData)
      .subscribe((res: any) => {
        if (res['status']) {
          if (res['response']) {
            this._service.toasterService({
              type: 'success',
              msg: res['response']['message'],
            });
            this._activeModal.close(true);
          } else {
            this.errorMessage =
              res['response']['message'] + ' - ' + res['response']['error'];
            // this._service.toasterService({ type: 'error', msg: res['response']['message'] });
          }
        } else {
          this.errorMessage =
            res['response']['message'] + ' - ' + res['response']['error'];
          // this._service.toasterService({ type: 'error', msg: res['response']['message'] });
        }
      });
  }

  get formValues() {
    return this.alertRuleForm.controls;
  }

  private _buildForm() {
    this.alertRuleForm = this._fb.group({
      siteId: [],
      alertId: ['', [Validators.required]],
      alertDesc: [
        '',
        [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)],
      ],
      class: [''],
      type: [''],
      alertSeverity: [''],
      action: [''],
      alertCategory: [''],
      categoryNature: [''],
      excludedZoneRiskTypes: [''],
      sms: [false],
      email: [false],
      c2d: [false],
      webNotification: [false],
      pushNotification: [false],
      autoClose: [false],
      mtype: [0, [Validators.required]],
      message: [
        '',
        [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)],
      ],
      triggerDelay: [0, [Validators.required]],
      allowDuplicates: [false],
      duplicateDuration: [],
      delayAlertDuration: [0, [Validators.required]],
      uom: [''],
      active: [true, [Validators.required]],
    });

    // Toggle validators for duplicateDuration based on allowDuplicates value
    const allowCtrl = this.alertRuleForm.get('allowDuplicates');
    if (allowCtrl) {
      // initial state
      this._toggleDuplicateDurationValidator(!!allowCtrl.value);
      this._allowDuplicatesSub = allowCtrl.valueChanges.subscribe((val: any) => {
        this._toggleDuplicateDurationValidator(!!val);
      });
    }
  }

  private _toggleDuplicateDurationValidator(isRequired: boolean) {
    const ctrl = this.alertRuleForm.get('duplicateDuration');
    if (!ctrl) return;
    if (isRequired) {
      ctrl.setValidators([Validators.required]);
    } else {
      ctrl.clearValidators();
    }
    ctrl.updateValueAndValidity();
  }

  private _patchValue(data?: any) {
    if (data && (this.tabType === 'site' || this.tabType === 'tenant')) {
      this.alertValue = data['alertId'];
      this.alertRuleForm.patchValue({ alertId: data['alertId'] });
      this.alertRuleForm.patchValue({ alertDesc: data['alertDesc'] });
      this.alertRuleForm.patchValue({ sms: data['sms'] });
      this.alertRuleForm.patchValue({ email: data['email'] });
      this.alertRuleForm.patchValue({ c2d: data['c2d'] });
      this.alertRuleForm.patchValue({
        webNotification: data['webNotification'],
      });
      this.alertRuleForm.patchValue({
        pushNotification: data['pushNotification'],
      });
      this.alertRuleForm.patchValue({ autoClose: data['autoClose'] });
      this.alertRuleForm.patchValue({ mtype: data['mtype'] });
      this.alertRuleForm.patchValue({ message: data['message'] });
      this.alertRuleForm.patchValue({ type: data['type'] });
      this.alertRuleForm.patchValue({ triggerDelay: data['triggerDelay'] });
      this.alertRuleForm.patchValue({
        allowDuplicates: data['allowDuplicates'] === undefined ? false : data['allowDuplicates'],
      });
      this.alertRuleForm.patchValue({
        duplicateDuration: data['duplicateDuration'],
      });
      this.alertRuleForm.patchValue({
        delayAlertDuration: data['delayAlertDuration'],
      });
      this.alertRuleForm.patchValue({ active: data['active'] });
      this.alertRuleForm.patchValue({ alertSeverity: data['alertSeverity'] });
      this.alertRuleForm.patchValue({ action: data['action'] });
      this.alertRuleForm.patchValue({ alertCategory: data['alertCategory'] });
      this.alertRuleForm.patchValue({ class: data['class'] });
      this.alertRuleForm.patchValue({ categoryNature: data['categoryNature'] });
      this.alertRuleForm.patchValue({
        excludedZoneRiskTypes: data['excludedZoneRiskTypes'][0],
      });
      this.alertRuleForm.patchValue({ uom: data['uom'] });
      this._autoCloseFieldChange(data['autoClose']);
    } else {
      if (this.alertRuleAdd) {
        this.alertRuleForm.patchValue({
          alertId: this.alertRuleAdd['alertId'],
        });
        this.alertRuleForm.patchValue({
          alertSeverity: this.alertSeveritydd[0],
        });
        this.alertRuleForm.patchValue({ action: this.alertActionsdd[0] });
        this.alertRuleForm.patchValue({
          alertCategory: this.alertCategorydd[0],
        });
        this.alertRuleForm.patchValue({ class: this.classType[0] });
        this.alertRuleForm.patchValue({
          type:
            this.tabType === 'global'
              ? 'global'
              : this.alertRuleForm.value.type,
        });
        this.alertRuleForm.patchValue({
          categoryNature: this.alertCategoryNaturedd[0],
        });
        this.alertRuleForm.patchValue({
          excludedZoneRiskTypes: this.zoneRiskTypeList[0],
        });
        this.alertRuleForm.patchValue({ uom: this.uom[0] });
        this._autoCloseFieldChange(false);
      }
      if (this.alertRuleData) {
        this.alertValue = this.alertRuleData['alertId'];
        this.alertRuleForm.patchValue({
          alertId: this.alertRuleData['alertId'],
        });
        this.alertRuleForm.patchValue({
          alertDesc: this.alertRuleData['alertDesc'],
        });
        this.alertRuleForm.patchValue({ sms: this.alertRuleData['sms'] });
        this.alertRuleForm.patchValue({ email: this.alertRuleData['email'] });
        this.alertRuleForm.patchValue({ c2d: this.alertRuleData['c2d'] });
        this.alertRuleForm.patchValue({
          webNotification: this.alertRuleData['webNotification'],
        });
        this.alertRuleForm.patchValue({
          pushNotification: this.alertRuleData['pushNotification'],
        });
        this.alertRuleForm.patchValue({
          autoClose: this.alertRuleData['autoClose'],
        });
        this.alertRuleForm.patchValue({ mtype: this.alertRuleData['mtype'] });
        this.alertRuleForm.patchValue({
          message: this.alertRuleData['message'],
        });
        this.alertRuleForm.patchValue({
          triggerDelay: this.alertRuleData['triggerDelay'],
        });
        this.alertRuleForm.patchValue({
          allowDuplicates: this.alertRuleData['allowDuplicates'] === undefined ? false : this.alertRuleData['allowDuplicates'],
        });
        this.alertRuleForm.patchValue({
          duplicateDuration: this.alertRuleData['duplicateDuration'],
        });
        this.alertRuleForm.patchValue({
          delayAlertDuration: this.alertRuleData['delayAlertDuration'],
        });
        this.alertRuleForm.patchValue({ active: this.alertRuleData['active'] });
        this.alertRuleForm.patchValue({
          alertSeverity: this.alertRuleData['alertSeverity'],
        });
        this.alertRuleForm.patchValue({ action: this.alertRuleData['action'] });
        this.alertRuleForm.patchValue({
          alertCategory: this.alertRuleData['alertCategory'],
        });
        this.alertRuleForm.patchValue({ class: this.alertRuleData['class'] });
        this.alertRuleForm.patchValue({ type: this.alertRuleData['type'] });
        this.alertRuleForm.patchValue({
          categoryNature: this.alertRuleData['categoryNature'],
        });
        this.alertRuleForm.patchValue({
          excludedZoneRiskTypes: this.alertRuleData['excludedZoneRiskTypes'][0],
        });
        this.alertRuleForm.patchValue({ uom: this.alertRuleData['uom'] });
        this._autoCloseFieldChange(this.alertRuleData['autoClose']);
      }
      if (!this.alertRuleAdd && !this.alertRuleEdit) {
        this.alertRuleForm.disable();
      }
    }
    if (this.alertRuleData) {
      if (this.tabType === 'site' || this.tabType === 'tenant') {
        this.alertRuleForm.controls['alertId'].disable();
        this.alertRuleForm.controls['alertDesc'].disable();
        this.alertRuleForm.controls['uom'].disable();
      } else if (this.tabType === 'global') {
        this.alertRuleForm.controls['alertId'].disable();
      }
    }
  }

  private _configurationInfo() {
    // this._service.configurationsInfo(this.attribute).subscribe((res: any) => {
    //   if (res['status']) {
    //     let data: any = res['response']
    //     data.forEach((element: any) => {
    //       if (element['attribute'] === 'alertSeverity') {
    //         element['values']['alertSeverity'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['alertSeverity'].forEach((element2: any) => {
    //           this.alertSeveritydd.push(element2['name'])
    //         });
    //       }
    //       if (element['attribute'] === 'alertAction') {
    //         element['values']['alertAction'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['alertAction'].forEach((element2: any) => {
    //           this.alertActionsdd.push(element2['name'])
    //         });
    //       }
    //       if (element['attribute'] === 'alertCategory') {
    //         element['values']['alertCategory'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['alertCategory'].forEach((element2: any) => {
    //           this.alertCategorydd.push(element2['name'])
    //         });
    //       }
    //       if (element['attribute'] === 'categoryNature') {
    //         element['values']['categoryNature'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['categoryNature'].forEach((element2: any) => {
    //           this.alertCategoryNaturedd.push(element2['name'])
    //         });
    //       }
    //       if (element['attribute'] === 'unitOfMeasurement') {
    //         element['values']['measurement'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['measurement'].forEach((element2: any) => {
    //           this.uom.push(element2['name'])
    //         });
    //       }
    //       if (element['attribute'] === 'typ') {
    //         element['values']['scope'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['scope'].forEach((element2: any) => {
    //           this.scope.push(element2['name'])
    //         });
    //       }
    //       if (element['attribute'] === 'classType') {
    //         element['values']['classType'].sort((a: any, b: any) => a.index - b.index);
    //         element['values']['classType'].forEach((element2: any) => {
    //           this.classType.push(element2['name'])
    //         });
    //       }
    //       //NS112
    //       if (element['attribute'] === 'zoneRiskType') {
    //         let data = element['values']['zoneRiskType'];
    //         let d1: any = []
    //         data.forEach((elements: any) => {
    //           d1.push(elements['name'])
    //         });
    //         this.zoneRiskTypeList = d1;
    //       }
    //       //NS112
    //     });
    //     this.patchValue();
    //   }
    // });

    this.uom = this._service.getConfiguration('unitOfMeasurement')
      ? this._service
          .getConfiguration('unitOfMeasurement')
          ['measurement'].sort((a: any, b: any) => a.index - b.index)
          ?.map(({ name }) => name)
      : [];
    this.scope = this._service.getConfiguration('typ')
      ? this._service
          .getConfiguration('typ')
          ['scope'].sort((a: any, b: any) => a.index - b.index)
          ?.map(({ name }) => name)
      : [];
    this.alertSeveritydd = this._service.getConfiguration('alertSeverity')
      ? this._service
          .getConfiguration('alertSeverity')
          ['alertSeverity'].sort((a: any, b: any) => a.index - b.index)
          ?.map(({ name }) => name)
      : [];
    this.alertActionsdd = this._service.getConfiguration('alertAction')
      ? this._service
          .getConfiguration('alertAction')
          ['alertAction'].sort((a: any, b: any) => a.index - b.index)
          ?.map(({ name }) => name)
      : [];
    this.alertCategorydd = this._service.getConfiguration('alertCategory')
      ? this._service
          .getConfiguration('alertCategory')
          ['alertCategory'].sort((a: any, b: any) => a.index - b.index)
          ?.map(({ name }) => name)
      : [];
    this.alertCategoryNaturedd = this._service.getConfiguration(
      'categoryNature'
    )
      ? this._service
          .getConfiguration('categoryNature')
          ['categoryNature'].sort((a: any, b: any) => a.index - b.index)
          ?.map(({ name }) => name)
      : [];
    this.classType = this._service.getConfiguration('classType')
      ? this._service
          .getConfiguration('classType')
          ['classType'].sort((a: any, b: any) => a.index - b.index)
          ?.map(({ name }) => name)
      : [];
    this.zoneRiskTypeList = this._service.getConfiguration('zoneRiskType')
      ? this._service
          .getConfiguration('zoneRiskType')
          ['zoneRiskType']?.map(({ name }) => name)
      : [];
    this._patchValue();
  }

  private _autoCloseFieldChange(condition: boolean) {
    if (condition) {
      this.autoCloseTrigger = false;
      this.formLabelName = 'Auto Update Delay';
    } else {
      this.autoCloseTrigger = true;
      this.formLabelName = 'Duplicate Duration';
    }
  }
}
